import React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';

import { SortingTypes } from '../ecp-sort.models';

export const useSortButtons = () => {
  const intl = useIntl();

  return [{
    value: SortingTypes.distance,
    testId: 'ecp-sort-distance-option', //Don't remove data-testid, it's used by Ya Metrica
    label: (
      <span aria-label={intl.formatMessage({ id: 'ecp.sortButton.distance.ariaLabel' })}>
        <FormattedMessage
          id="ecp.sortButton.distance.label"
        />
      </span>
    ),
    selectedLabel: (
      <span aria-label={intl.formatMessage({ id: 'ecp.sortButton.distance.ariaLabel' })}>
        <FormattedMessage id="ecp.sortButton.label" />
        <FormattedMessage id="ecp.sortButton.distance.label" />
      </span>
    ),
  }, {
    value: SortingTypes.rating,
    testId: 'ecp-sort-rating-option', //Don't remove data-testid, it's used by Ya Metrica
    label: (
      <span aria-label={intl.formatMessage({ id: 'ecp.sortButton.rating.ariaLabel' })}>
        <FormattedMessage
          id="ecp.sortButton.rating.label"
        />
      </span>
    ),
    selectedLabel: (
      <span aria-label={intl.formatMessage({ id: 'ecp.sortButton.rating.ariaLabel' })}>
        <FormattedMessage id="ecp.sortButton.label" />
        <FormattedMessage id="ecp.sortButton.rating.label" />
      </span>
    ),
  }];
};
